import React, { useState, useRef } from 'react';

function App() {
  const [imageSrc, setImageSrc] = useState('index.gif');
  const [isLoading, setIsLoading] = useState(false);
  const [gifBlob, setGifBlob] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false); // Controla si el GIF fue cargado desde la API
  const imageRef = useRef(null);

  const handleNextClick = async () => {
    if (isLoading) return;
    
    setIsLoading(true);
    setIsLoaded(false); // Resetear el estado de carga
    
    try {
      // Simulate fetching a new GIF - you can replace this with your actual endpoint
      // For demo purposes, we'll use a placeholder service or cycle through local images
      const timestamp = Date.now();
      const response = await fetch(`/video.gif?t=${timestamp}`).catch(() => {
        // Fallback: use a placeholder image service or cycle through available images
        const placeholderUrls = [
          'https://via.placeholder.com/400x300/FF6B6B/FFFFFF.gif?text=Sample+GIF+1',
          'https://via.placeholder.com/400x300/4ECDC4/FFFFFF.gif?text=Sample+GIF+2',
          'https://via.placeholder.com/400x300/45B7D1/FFFFFF.gif?text=Sample+GIF+3',
          'https://via.placeholder.com/400x300/96CEB4/FFFFFF.gif?text=Sample+GIF+4',
          'https://via.placeholder.com/400x300/FFEAA7/000000.gif?text=Sample+GIF+5'
        ];
        const randomUrl = placeholderUrls[Math.floor(Math.random() * placeholderUrls.length)];
        return fetch(randomUrl);
      });
      
      const blob = await response.blob();
      setGifBlob(blob);
      
      const reader = new FileReader();
      reader.onload = (event) => {
        setImageSrc(event.target.result);
        setIsLoading(false);
        setIsLoaded(true); // Marcar como cargado exitosamente
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error loading image:', error);
      setImageSrc('error.gif');
      setIsLoading(false);
      setIsLoaded(false); // No permitir guardar si hay error
    }
  };

  const handleSaveClick = () => {
    // Solo permitir guardar si el GIF fue cargado exitosamente desde la API
    if (gifBlob && gifBlob.size > 0 && isLoaded) {
      const a = document.createElement('a');
      const url = URL.createObjectURL(gifBlob);
      document.body.appendChild(a);
      a.href = url;
      a.download = `TeraPorn-${Date.now()}.gif`;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    }
  };

  const handleImageError = () => {
    setImageSrc('error.gif');
    setIsLoading(false);
    setIsLoaded(false); // No permitir guardar si hay error de imagen
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 flex flex-col items-center justify-center p-4">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-6xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 mb-4 tracking-wider">
          TeraPorn
        </h1>
        <div className="w-24 h-1 bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 mx-auto rounded-full"></div>
      </div>

      {/* Image Container */}
      <div className="relative mb-8 max-w-4xl w-full">
        <div className="bg-gray-800 rounded-xl p-4 shadow-2xl border border-gray-700">
          <img
            ref={imageRef}
            id="image"
            src={imageSrc}
            alt="TeraPorn Content"
            className="w-full h-auto rounded-lg border border-gray-600 shadow-lg"
            onError={handleImageError}
            onLoad={handleImageLoad}
            fetchPriority="high"
          />
          {isLoading && (
            <div className="absolute inset-0 bg-gray-900 bg-opacity-75 rounded-xl flex items-center justify-center">
              <div className="flex flex-col items-center">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-500 mb-4"></div>
                <span className="text-gray-300 text-lg">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Control Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <button
          onClick={handleNextClick}
          disabled={isLoading}
          className="group relative px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 disabled:from-gray-600 disabled:to-gray-600 text-white font-bold text-xl rounded-xl shadow-lg transform transition-all duration-200 hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed active:scale-95 border border-purple-400 hover:border-pink-400 disabled:border-gray-500"
        >
          <span className="flex items-center gap-2">
            {isLoading ? (
              <>
                <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                Loading...
              </>
            ) : (
              <>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
                Next
              </>
            )}
          </span>
        </button>

        <div className="text-gray-500 text-xl font-bold">•</div>

        <button
          onClick={handleSaveClick}
          disabled={!gifBlob || gifBlob.size === 0 || !isLoaded}
          className="group relative px-8 py-4 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-500 hover:to-blue-500 disabled:from-gray-600 disabled:to-gray-600 text-white font-bold text-xl rounded-xl shadow-lg transform transition-all duration-200 hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed active:scale-95 border border-green-400 hover:border-blue-400 disabled:border-gray-500"
        >
          <span className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Save
          </span>
        </button>
      </div>

      {/* Status Indicator */}
      <div className="mt-6 text-center">
        <div className="flex items-center justify-center gap-2 text-gray-400">
          <div className={`w-2 h-2 rounded-full ${gifBlob && isLoaded ? 'bg-green-500' : 'bg-gray-600'}`}></div>
          <span className="text-sm">
            {gifBlob && isLoaded ? 'Content ready to save' : 'Load content from API to enable save'}
          </span>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <p className="text-gray-500 text-sm">
          Click <span className="text-purple-400 font-semibold">Next</span> to load new content • 
          Click <span className="text-green-400 font-semibold">Save</span> to download
        </p>
      </div>
    </div>
  );
}

export default App;
